import { useMixPanelForTracking } from "../../../shared_utilities/trackMixPanel";

export const useIndentMixpanelTrack = () => {
  const { TrackMixPanel } = useMixPanelForTracking();

  const trackIndentEvent = (screenName, definition, data = "None") => {

    TrackMixPanel({
      ModuleName: "lorri indent",
      ScreenName : screenName,
      Data : data,
      Definition : definition,
    });
  };

  return { trackIndentEvent };
};
